import { extendObservable } from 'mobx'

function createEmptyAddress () {
  return {
    address1: null,
    address2: null,
    city: null,
    countryId: null,
    emails: [{ email: '' }],
    id: null,
    phones: [{ phoneNumber: '' }],
    postalCode: null,
    revisionHash: null,
    state: null,
    timezoneId: null
  }
}

function createEmptyInnerExpert () {
  return {
    codeCounter: null,
    complianceDate: null,
    complianceIp: null,
    complianceLanguageId: null,
    complianceRequestedBy: null,
    complianceSigned: null,
    complianceReferrer: null,
    connectLinkedIn: null,
    connectXing: null,
    created_at: null,
    expertCode: null,
    expertIndex: null,
    expertLabelId: null,
    expertStatusId: null,
    id: null,
    industryExpertise: null,
    industryId: null,
    newsletter: null,
    oldNid: null,
    revisionHash: null,
    subIndustryId: null,
    updatedBy: null,
    updated_at: null,
    userId: null,
    websiteApproved: null,
    websiteFeatured: null
  }
}

function createEmptyExpert () {
  return {
    address: createEmptyAddress(),
    addressId: null,
    averageFeedback: null,
    confirmed: null,
    created_at: null,
    email: null,
    experiences: [],
    expert: createEmptyInnerExpert(),
    firstName: null,
    fullName: null,
    id: null,
    languages: null,
    lastLogin: null,
    lastName: null,
    linkedInConnected: null,
    links: [{ link: '' }],
    middleName: null,
    originalName: null,
    picture: null,
    pictureId: null,
    status: null,
    tags: [],
    title: '',
    updated_at: null,
    userTypeId: null,
    username: null,
    welcomed: null
  }
}

export default class Expert {
  constructor (data) {
    const expertData = data || createEmptyExpert()
    extendObservable(this, {
      loading: false,
      error: null,
      ...expertData
    })
  }
}

// ==========================================================================
// import { types: t, onSnapshot } from "mobx-state-tree"

// const MyModel = t.model({
//     id: t.number,
//     title: t.string,
//     firstName: t.string,
//     lastName: t.string,
//     middleName: t.null,
//     fullName: t.string,
//     originalName: t.null,
//     username: t.string,
//     email: t.null,
//     userTypeId: t.number,
//     status: t.boolean,
//     addressId: t.number,
//     pictureId: t.null,
//     created_at: t.string,
//     updated_at: t.string,
//     confirmed: t.boolean,
//     welcomed: t.boolean,
//     lastLogin: t.null,
//     expert: t.model({
//         id: t.number,
//         oldNid: t.null,
//         userId: t.number,
//         connectLinkedIn: t.boolean,
//         connectXing: t.boolean,
//         industryExpertise: t.string,
//         industryId: t.number,
//         subIndustryId: t.number,
//         expertCode: t.string,
//         codeCounter: t.null,
//         complianceSigned: t.boolean,
//         complianceDate: t.string,
//         complianceUrl: t.string,
//         websiteApproved: t.boolean,
//         websiteFeatured: t.boolean,
//         newsletter: t.boolean,
//         expertIndex: t.null,
//         expertLabelId: t.null,
//         expertStatusId: t.number,
//         revisionHash: t.string,
//         complianceRequestedBy: t.number,
//         complianceLanguageId: t.null,
//         complianceIp: t.null,
//         complianceFirstName: t.null,
//         complianceLastName: t.null,
//         updatedBy: t.null,
//         created_at: t.string,
//         updated_at: t.string,
//         expertStatus: t.model({
//             id: t.number,
//             name: t.string,
//             updatedBy: t.null,
//             created_at: t.string,
//             updated_at: t.string
//         })
//     }),
//     picture: t.null,
//     address: t.model({
//         id: t.number,
//         address1: t.string,
//         address2: t.null,
//         city: t.string,
//         state: t.string,
//         postalCode: t.string,
//         countryId: t.number,
//         timezoneId: t.number,
//         userId: t.null,
//         revisionHash: t.string,
//         updatedBy: t.null,
//         created_at: t.string,
//         updated_at: t.string,
//         country: t.model({
//             id: t.number,
//             name: t.string,
//             isoCode2: t.string,
//             isoCode3: t.string,
//             isSepa: t.boolean,
//             expertFocusRegionId: t.number,
//             invoicingRegionId: t.number,
//             timezoneId: t.number,
//             updatedBy: t.null,
//             created_at: t.string,
//             updated_at: t.string
//         }),
//         emails: t.array,
//         phones: t.array(t.model({
//             id: t.number,
//             addressId: t.number,
//             phoneNum: t.string,
//             phoneTypeId: t.number,
//             revisionHash: t.null,
//             updatedBy: t.null,
//             created_at: t.null,
//             updated_at: t.null
//         }))
//     }),
//     languages: t.array(t.model({
//         id: t.number,
//         oldNid: t.number,
//         name: t.string,
//         updatedBy: t.null,
//         created_at: t.string,
//         updated_at: t.string,
//         languageToUser: t.model({
//             id: t.number,
//             userId: t.number,
//             languageId: t.number,
//             languageProficiencyId: t.number,
//             revisionHash: t.string,
//             updatedBy: t.null,
//             created_at: t.string,
//             updated_at: t.string
//         })
//     })),
//     tags: t.array,
//     experiences: t.array(t.model({
//         startDate: t.null,
//         endDate: t.null,
//         id: t.number,
//         oldNid: t.null,
//         expertId: t.number,
//         company: t.string,
//         position: t.string,
//         location: t.null,
//         current: t.boolean,
//         description: t.null,
//         revisionHash: t.string,
//         updatedBy: t.null,
//         created_at: t.string,
//         updated_at: t.string
//     })),
//     links: t.array(t.model({
//         id: t.number,
//         expertId: t.number,
//         professionalLinkUrl: t.string,
//         revisionHash: t.string,
//         updatedBy: t.null,
//         created_at: t.string,
//         updated_at: t.string
//     })),
//     averageFeedback: t.null,
//     linkedInConnected: t.boolean,
//     _original: t.model({
//         id: t.number,
//         title: t.string,
//         firstName: t.string,
//         lastName: t.string,
//         middleName: t.null,
//         fullName: t.string,
//         originalName: t.null,
//         username: t.string,
//         email: t.null,
//         userTypeId: t.number,
//         status: t.boolean,
//         addressId: t.number,
//         pictureId: t.null,
//         created_at: t.string,
//         updated_at: t.string,
//         confirmed: t.boolean,
//         welcomed: t.boolean,
//         lastLogin: t.null,
//         expert: t.model({
//             id: t.number,
//             oldNid: t.null,
//             userId: t.number,
//             connectLinkedIn: t.boolean,
//             connectXing: t.boolean,
//             industryExpertise: t.string,
//             industryId: t.number,
//             subIndustryId: t.number,
//             expertCode: t.string,
//             codeCounter: t.null,
//             complianceSigned: t.boolean,
//             complianceDate: t.string,
//             complianceUrl: t.string,
//             websiteApproved: t.boolean,
//             websiteFeatured: t.boolean,
//             newsletter: t.boolean,
//             expertIndex: t.null,
//             expertLabelId: t.null,
//             expertStatusId: t.number,
//             revisionHash: t.string,
//             complianceRequestedBy: t.number,
//             complianceLanguageId: t.null,
//             complianceIp: t.null,
//             complianceFirstName: t.null,
//             complianceLastName: t.null,
//             updatedBy: t.null,
//             created_at: t.string,
//             updated_at: t.string,
//             expertStatus: t.model({
//                 id: t.number,
//                 name: t.string,
//                 updatedBy: t.null,
//                 created_at: t.string,
//                 updated_at: t.string
//             })
//         }),
//         picture: t.null,
//         address: t.model({
//             id: t.number,
//             address1: t.string,
//             address2: t.null,
//             city: t.string,
//             state: t.string,
//             postalCode: t.string,
//             countryId: t.number,
//             timezoneId: t.number,
//             userId: t.null,
//             revisionHash: t.string,
//             updatedBy: t.null,
//             created_at: t.string,
//             updated_at: t.string,
//             country: t.model({
//                 id: t.number,
//                 name: t.string,
//                 isoCode2: t.string,
//                 isoCode3: t.string,
//                 isSepa: t.boolean,
//                 expertFocusRegionId: t.number,
//                 invoicingRegionId: t.number,
//                 timezoneId: t.number,
//                 updatedBy: t.null,
//                 created_at: t.string,
//                 updated_at: t.string
//             }),
//             emails: t.array,
//             phones: t.array(t.model({
//                 id: t.number,
//                 addressId: t.number,
//                 phoneNum: t.string,
//                 phoneTypeId: t.number,
//                 revisionHash: t.null,
//                 updatedBy: t.null,
//                 created_at: t.null,
//                 updated_at: t.null
//             }))
//         }),
//         languages: t.array(t.model({
//             id: t.number,
//             oldNid: t.number,
//             name: t.string,
//             updatedBy: t.null,
//             created_at: t.string,
//             updated_at: t.string,
//             languageToUser: t.model({
//                 id: t.number,
//                 userId: t.number,
//                 languageId: t.number,
//                 languageProficiencyId: t.number,
//                 revisionHash: t.string,
//                 updatedBy: t.null,
//                 created_at: t.string,
//                 updated_at: t.string
//             })
//         })),
//         tags: t.array,
//         experiences: t.array(t.model({
//             startDate: t.null,
//             endDate: t.null,
//             id: t.number,
//             oldNid: t.null,
//             expertId: t.number,
//             company: t.string,
//             position: t.string,
//             location: t.null,
//             current: t.boolean,
//             description: t.null,
//             revisionHash: t.string,
//             updatedBy: t.null,
//             created_at: t.string,
//             updated_at: t.string
//         })),
//         links: t.array(t.model({
//             id: t.number,
//             expertId: t.number,
//             professionalLinkUrl: t.string,
//             revisionHash: t.string,
//             updatedBy: t.null,
//             created_at: t.string,
//             updated_at: t.string
//         })),
//         averageFeedback: t.null,
//         linkedInConnected: t.boolean
//     })
// });
